(function() {
  'use strict';

  angular
    .module('admin.product_lines.service', [])
    .factory('ProductLinesService', ProductLinesService);

  /** @ngInject */
  function ProductLinesService($http, $q, API) {

    function list(start, limit, sort){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/product_lines?start=' + start + '&limit=' + limit + '&sort=' + sort)
          .success(defered.resolve);

        return defered.promise;
    }

    function get(id){
        var defered = $q.defer();

        $http.get(API.API_URL + 'admin/product_lines/' + id)
          .success(defered.resolve);

        return defered.promise;
    }

    function save(model){
        var defered = $q.defer();

        $http.post(API.API_URL + 'admin/product_lines', model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function update(id, model){
        var defered = $q.defer();

        $http.put(API.API_URL + 'admin/product_lines/' + id, model)
          .success(defered.resolve)
          .error(function(result){
            swal(result.error.message, "", "error");
          });

        return defered.promise;
    }

    function remove(id){
        var defered = $q.defer();

        $http.delete(API.API_URL + 'admin/product_lines/' + id)
          .success(defered.resolve)
          .error(defered.reject);

        return defered.promise;
    }

    return{
        list: list,
        get: get,
        save: save,
        update: update,
        remove: remove
    };

  }

})();
